import { defineMessages } from "react-intl";

export const messages = defineMessages({
    sidebarTitle: {
        id: "UsageBasedPricing.CapacitySidebar.title",
        defaultMessage: "Estimated total org allowance"
    },
    adjustInputsMessage: {
        id: "UsageBasedPricing.CapacitySidebar.adjustInputs",
        defaultMessage:
            "Allowance estimate is based on your team's work type and size."
    },
    creditsLabel: {
        id: "UsageBasedPricing.CapacitySidebar.creditsLabel",
        defaultMessage: "Rovo Credits Per Month"
    },
    explorePlansLink: {
        id: "UsageBasedPricing.CapacitySidebar.explorePlansLink",
        defaultMessage: "Explore plans to suit your usage needs"
    },
    sidebarDisclaimer: {
        id: "UsageBasedPricing.CapacitySidebar.disclaimer",
        defaultMessage:
            "This estimate isn't binding for either you or Atlassian. Figures shown here are intended to show an estimation of usage allowance, and may be subject to change."
    },
    explorePlansLinkText: {
        id: "UsageBasedPricing.CapacitySidebar.explorePlansLinkText",
        defaultMessage: "Explore plans to suit your usage needs"
    }
});
